import { styled } from 'lib/ui';

export const MealIndexBadge = styled.div.attrs({ className: 'MealIndexBadge' })`
  padding: ${p => p.theme.spaceSmallX} ${p => p.theme.spaceSmall};
  background: #eee;
  border-radius: 50%;
  flex-shrink: 0 !important;
`;
